import React from 'react';
import { BlocksHeader } from '@noths/polaris-client-ribbons-design-system';
import { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { ProductOptionValue } from 'src/types';
import { getPersonalisationAmount } from 'src/utils';

interface ToggleButtonProps {
  currency: CurrencyCode;
  value: ProductOptionValue;
  isSelected: boolean;
  onClick: (value: ProductOptionValue | null) => void;
  onFocus?: VoidFunction;
}

export const ToggleButton = ({
  currency,
  value,
  isSelected,
  onClick,
  onFocus,
}: ToggleButtonProps) => {
  const { value: price } = getPersonalisationAmount(currency, value.priceModifier);

  const handleOnClick = () => {
    const newValue = isSelected ? null : value;

    onClick(newValue);
  };

  return (
    <BlocksHeader
      variant="check"
      isSelected={isSelected}
      label={value.name}
      price={price}
      currency={currency}
      onClick={handleOnClick}
      onFocus={onFocus}
    />
  );
};
